<template>
  <div v-if="product" class="popup-dv-mask" @click.self="$emit('close')">
    <div class="popup-dv">

      <!-- HEADER -->
      <div class="popup-dv-header">
        <span class="m-auto" style="font-size: 18px; font-weight: 700;">{{ product.name }}</span>
        <!-- <button @click="$emit('close')">✕</button> -->
      </div>

      <!-- TABS -->
      <div class="tab-bar">
        <div v-for="t in tabs" :key="t" :class="['tab', { active: activeTab === t }]" @click="activeTab = t">
          {{ t }}
        </div>
      </div>

      <!-- CONTENT -->
      <div class="tab-content">

        <!-- TAB SẢN PHẨM -->
        <div v-if="activeTab === 'Sản phẩm'">

          <!-- ẢNH -->
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 col-md-7">
                <div class="d-flex">
                  <div class="main-img m-auto">
                    <img :src="currentImage" />
                  </div>

                  <div class="thumb-list flex-column">
                    <div v-for="(img, i) in images" :key="i" class="thumb" :class="{ active: img === currentImage }"
                      @click="currentImage = img">
                      <img :src="img" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- col-12 d-block d-md-none -->
              <div class="col-12 d-block d-md-none">
                <div v-if="comboProducts.length" class="combo-box mt-3">
                  <div class="combo-title">
                    🎁 Sản phẩm trong combo
                  </div>

                  <div class="combo-list">
                    <div v-for="sp in comboProducts" :key="sp.id" class="combo-item"
                      :class="{ active: selectedComboIds.includes(sp.id) }">

                      <img :src="sp.comboImg" class="combo-img" />

                      <div class="combo-name">
                        {{ sp.comboName }}
                      </div>

                      <div class="combo-price" style="color: blue;">
                        {{ currenLang.textSanPhamThue }} :
                        {{ formatPrice(sp.giaThue) }}₫
                      </div>

                      <div class="combo-price">
                        {{ currenLang.textSanPhamBan }} :
                        {{ formatPrice(getComboPrice(sp)) }}₫
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-5">
                <!-- CHIẾT KHẤU -->
                <div class="discount-box mt-4">
                  <div v-for="s in saleList" :key="s" class="discount-row" :class="{ active: autoSale === s }">
                    <div class="discount-left">{{ currenLang.textSanPham_ChietKhau }} {{ s }}%</div>
                    <div class="discount-right"> {{ saleRules[Number(s)]?.text }}
                    </div>
                  </div>
                </div>

                <!-- SỐ LƯỢNG -->
                <div class="qty-box">
                  <div class="qty-label">{{ currenLang.textSanPham_Soluong }}</div>
                  <div class="qty-control justify-content-between">
                    <button @click="decreaseQty">−</button>
                    <input type="number" v-model.number="quantity" @input="onQtyChange" />
                    <button @click="increaseQty">+</button>
                  </div>
                  <div v-if="autoSale" class="sale-badge mt-3" style="color: red;">
                    🔖 Đã áp dụng - {{ autoSale }}%
                  </div>
                  <!-- <div v-if="autoSale" class="save">
                🎉 Tiết kiệm
                {{ formatPrice(baseSellPrice * quantity - buyPrice) }}₫ 
              </div> -->
                </div>
                <div style="font-size: 13px; " class="mt-3">
                  <i> (*)
                    {{ currenLang.textSanPham_PhuongThuc }}
                  </i>
                </div>

                <div v-if="suggestedProducts.length" class="suggested-box mt-4 d-none">
                  <div class="suggested-title">
                    🔥 {{ currenLang.textSanPham_GoiY }}
                  </div>

                  <div class="suggested-list">
                    <div v-for="sp in suggestedProducts" :key="sp.id" class="suggested-item"
                      :class="{ active: selectedSuggestId === sp.id }" @click="toggleSuggest(sp)">
                      <img :src="sp.image.split(';')[0]" class="suggested-img" />

                      <div class="suggested-name text-center">
                        {{ sp.name }}
                      </div>

                      <div class="suggested-price text-center">
                        + {{ activeTab === 'Sản phẩm'
                          ? formatPrice(sp.giaThue)
                          : formatPrice(sp.price)
                        }}₫
                      </div>

                      <div v-if="selectedSuggestId === sp.id" class="check-icon">
                        ✔
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <!-- d-md-block -->
              <div class="col-12 col-md-12 d-none d-md-block ">

                <div v-if="comboProducts.length" class="combo-box mt-4">
                  <div class="combo-title">
                    🎁 Sản phẩm trong combo
                  </div>

                  <div class="combo-list">
                    <!-- <div v-for="sp in comboProducts" :key="sp.id" class="combo-item" :class="{ active: selectedComboIds.includes(sp.id) }" @click="toggleCombo(sp)"> -->

                    <div v-for="sp in comboProducts" :key="sp.id" class="combo-item"
                      :class="{ active: selectedComboIds.includes(sp.id) }">
                      <img :src="sp.comboImg" class="combo-img" />

                      <div class="combo-name">
                        {{ sp.comboName }}
                      </div>

                      <div class="combo-price" style="color: blue;">
                        {{ currenLang.textSanPhamThue }} : {{
                          formatPrice(sp.giaThue)

                        }}₫
                      </div>


                      <div class="combo-price">
                        {{ currenLang.textSanPhamBan }} : {{ formatPrice(getComboPrice(sp)) }}₫
                      </div>

                      <div v-if="selectedComboIds.includes(sp.id)" class="check-icon">
                        ✔
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- CHIẾT KHẤU + SỐ LƯỢNG -->


          <!-- BADGE SALE -->


          <!-- GIÁ TÓM TẮT -->
          <div class="price-summary d-none">
            <div v-if="autoSale" class="price-row">
              <span>Giá gốc</span>
              <span class="old">
                {{ formatPrice(baseSellPrice * quantity) }}₫
              </span>
            </div>

            <div class="price-row highlight">
              <span>Giá sau ưu đãi</span>
              <span class="final">
                {{ formatPrice(buyPrice) }}₫
              </span>
            </div>


          </div>

        </div>

        <!-- TAB THÔNG TIN -->
        <div v-if="activeTab === 'Thông tin'" class="p-4">
          <div class="desc" v-html="formatDesc(product.description)"></div>
          <div class="desc mt-3" v-html="formatDesc(product.huongdan)"></div>
          <div style="font-size: 13px; font-weight: 600;" class="mt-3">
            {{ currenLang.textSanPham_HinhThucTT }}
          </div>
        </div>

      </div>

      <!-- FOOTER -->
      <!-- FOOTER -->
      <div class="popup-dv-footer">

        <!-- THUÊ -->
        <button v-if="rentPrice > 0" class="btn rent action-btn" @click="addToCart('rent', {
          product: product,
          quantity: quantity,
          unitPrice: Math.round(rentPrice / quantity),
          total: rentPrice,
          sale: autoSale
        })">
          <div class="btn-title">
            <span class="action-text">
              {{ currenLang.textSanPham_ThueNgay }} 📦
            </span>
            <span class="action-price">
              {{ formatPrice(rentPrice) }}₫
            </span>
          </div>
        </button>

        <!-- MUA -->
        <button v-if="buyPrice > 0" class="btn buy action-btn" @click="addToCart('buy', {
          product: product,
          quantity: quantity,
          unitPrice: Math.round(buyPrice / quantity),
          total: buyPrice,
          sale: autoSale
        })">
          <div class="btn-title">
            <span class="action-text">
              {{ currenLang.textSanPham_MuaNgay }} 🛒
            </span>
            <span class="action-price">
              {{ formatPrice(buyPrice) }}₫
            </span>
          </div>
        </button>

      </div>

    </div>
  </div>
  <div v-if="toast.show" class="toast">
    {{ toast.message }}
  </div>
</template>

<script>
import { languages } from '@/components/languages';

export default {
  props: { product: Object },

  data() {
    return {
      activeTab: "Sản phẩm",
      tabs: ["Sản phẩm", "Thông tin"],
      currentImage: "",
      quantity: 1,
      // products: [],
      products: require("@/components/json/jsonProduct.json"),
      selectedSuggestIds: [],
      selectedComboIds: [],
      selectedSuggestId: null,
      toast: {
        show: false,
        message: '',
      },
      currenLang: languages.vi
    };
  },
  created() {
    const savedLanguage = localStorage.getItem("languages") || "vi";
    if (savedLanguage && languages[savedLanguage]) {
      this.currenLang = languages[savedLanguage];
    }
  },
  computed: {

    comboProducts() {
      if (!this.product?.combosp?.length) return []

      return this.product.combosp.map(combo => {
        const realProduct = this.products.find(p => p.id === combo.id)

        if (!realProduct) return null

        return {
          ...realProduct,
          comboImg: combo.img,
          comboName: combo.name,
          giaCombo: combo.giaCombo

        }
      }).filter(Boolean)
    },
    comboTotal() {
      return this.comboProducts
        .filter(sp => this.selectedComboIds.includes(sp.id))
        .reduce((sum, sp) => {
          return sum + (
            this.activeTab === "Sản phẩm"
              ? Number(sp.giaThue)
              : Number(sp.price)
          )
        }, 0)
    },
    suggestTotal() {
      const sp = this.suggestedProducts.find(
        s => s.id === this.selectedSuggestId
      )
      if (!sp) return 0
      return this.activeTab === "Sản phẩm"
        ? Number(sp.giaThue)
        : Number(sp.price)
    },
    cartCount() {
      const cart = JSON.parse(localStorage.getItem("cart") || "[]")
      return cart.reduce((sum, i) => sum + i.quantity, 0)
    },
    images() {
      return this.product?.image?.split(";").filter(Boolean) || [];
    },

    saleList() {
      return this.product?.sale?.split(";").map(Number) || [];
    },

    saleRules() {
      return {
        5: { min: 5, max: 20, text: "5 – 20 sản phẩm" },
        10: { min: 21, max: 50, text: "21 – 50 sản phẩm" },
        15: { min: 51, max: Infinity, text: "Trên 50 sản phẩm" }
      };
    },

    autoSale() {
      let s = null;
      this.saleList.forEach(p => {
        const r = this.saleRules[p];
        if (r && this.quantity >= r.min && this.quantity <= r.max) s = p;
      });
      return s;
    },
    suggestedProducts() {
      if (!this.product?.idsanphamgoiy) return []

      const ids = this.product.idsanphamgoiy
        .split(';')
        .map(id => Number(id))
        .filter(Boolean)

      return this.products.filter(p => ids.includes(p.id))
    },
    baseSellPrice() {
      return Number(this.product?.priceTD) || 0;
    },

    baseRentPrice() {
      return Number(this.product?.giaThueTD) || 0;
    },

    buyPrice() {
      const priceTD = this.autoSale
        ? this.baseSellPrice * (100 - this.autoSale) / 100
        : this.baseSellPrice;

      return Math.round(priceTD * this.quantity)
        + this.comboTotal
        + this.suggestTotal;
    },

    rentPrice() {
      const priceTD = this.autoSale
        ? this.product?.giaThueSaleTD?.[this.autoSale] || this.baseRentPrice
        : this.baseRentPrice;

      return Math.round(priceTD * this.quantity)
        + this.comboTotal
        + this.suggestTotal;
    },
  },

  watch: {
    images: {
      immediate: true,
      handler(v) {
        if (v.length) this.currentImage = v[0];
      }
    }
  },

  methods: {
    getComboPrice(sp) {
      if (!sp.giaCombo) return 0

      const arr = sp.giaCombo.split(";")
      console.log("arr ", arr);

      const defaultPrice = Number(arr[0]) || 0
      const discountPrice = Number(arr[1]) || defaultPrice

      if (this.autoSale == 5) {
        return discountPrice
      } else if (this.autoSale == 10) {
        return discountPrice
      }

      return defaultPrice
    },
    toggleCombo(sp) {
      const index = this.selectedComboIds.indexOf(sp.id)

      if (index === -1) {
        this.selectedComboIds.push(sp.id)
      } else {
        this.selectedComboIds.splice(index, 1)
      }
    },
    toggleSuggest(sp) {
      // nếu click lại sản phẩm đang chọn → bỏ chọn
      if (this.selectedSuggestId === sp.id) {
        this.selectedSuggestId = null
      } else {
        this.selectedSuggestId = sp.id
      }
    },
    formatDesc(text) {
      if (!text) return ''
      return text
        .replace(/\n\n/g, '<br><br>')   // xuống dòng đoạn
        .replace(/\n/g, '<br>')        // xuống dòng thường
        .replace(/- /g, '• ')          // gạch ngang → bullet
    },
    increaseQty() { this.quantity++; },
    decreaseQty() { if (this.quantity > 1) this.quantity--; },
    onQtyChange() { if (this.quantity < 1) this.quantity = 1; },
    formatPrice(v) { return Number(v).toLocaleString("vi-VN"); },
    onBuy() {
      this.$emit("buy", {
        product: this.product,
        quantity: this.quantity,
        unitPrice: Math.round(this.buyPrice / this.quantity),
        total: this.buyPrice,
        sale: this.autoSale
      })
    },

    onRent() {
      this.$emit("rent", {
        product: this.product,
        quantity: this.quantity,
        unitPrice: Math.round(this.rentPrice / this.quantity),
        total: this.rentPrice,
        sale: this.autoSale
      })
    },
    addToCart(type) {
      const cart = JSON.parse(localStorage.getItem("cart") || "[]")

      const unitPrice = type === "buy"
        ? Math.round(this.buyPrice / this.quantity)
        : Math.round(this.rentPrice / this.quantity)

      const totalPrice = type === "buy"
        ? this.buyPrice
        : this.rentPrice

      // 🔍 Tìm sản phẩm đã tồn tại (cùng id + cùng type + cùng sale)
      const existingIndex = cart.findIndex(item =>
        item.id === this.product.id &&
        item.type === type &&
        item.sale === this.autoSale
      )

      if (existingIndex !== -1) {
        // ✅ Nếu đã có → cộng dồn số lượng
        cart[existingIndex].quantity += this.quantity
        cart[existingIndex].total += totalPrice
      } else {
        // ✅ Nếu chưa có → thêm mới
        cart.push({
          id: this.product.id,
          name: this.product.name,
          image: this.product.image?.split(";")[0],
          type,
          quantity: this.quantity,
          sale: this.autoSale,
          unitPrice,
          total: totalPrice
        })
      }

      localStorage.setItem("cart", JSON.stringify(cart))
      this.$emit("added-to-cart", cart)
      // this.$emit("close")
      window.location.reload();
    }
    // removeItem(index) {
    //   this.cartItems.splice(index, 1)
    //   localStorage.setItem("cart", JSON.stringify(this.cartItems))
    // },

  }
};
</script>

<style scoped>
/* ================= TOOLTIP ================= */

/* WRAP */

.combo-box {
  border-top: 1px solid #eee;
  padding-top: 10px;
}

.combo-title {
  font-weight: 600;
  margin-bottom: 10px;
}

.combo-list {
  display: flex;
  gap: 10px;
  overflow-x: auto;
}

.combo-item {
  min-width: 120px;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  transition: 0.2s;
  text-align: center;
}

.combo-item:hover {
  border-color: #1677ff;
  background: #f5f9ff;
}

.combo-img {
  width: 100%;
  height: 80px;
  object-fit: contain;
}

.combo-name {
  font-size: 13px;
  margin-top: 5px;
}

.combo-price {
  color: red;
  font-weight: 600;
  font-size: 13px;
}

.tooltip-dv-wrap {
  position: relative;
  cursor: pointer;
}

/* TOOLTIP BOX */
.tooltip-dv-box {
  position: absolute;
  bottom: 115%;
  left: 50%;
  transform: translateX(-50%) translateY(6px);
  width: 240px;

  background: #fff;
  border-radius: 12px;
  padding: 12px 14px;

  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
  font-size: 13px;
  line-height: 1.4;

  opacity: 0;
  pointer-events: none;
  transition: all .25s ease;

  z-index: 10001;
  /* 🔥 QUAN TRỌNG */
}

/* MŨI TÊN */
.tooltip-dv-box::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 8px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
}

/* HOVER */
.tooltip-dv-wrap:hover .tooltip-dv-box {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

/* TOOLTIP CONTENT */
.tooltip-dv-title {
  font-weight: 600;
  margin-bottom: 6px;
}

.tooltip-dv-line {
  margin-bottom: 4px;
}

.tooltip-dv-desc {
  margin-top: 6px;
  color: #555;
  font-size: 12px;
}

/* ================= SUGGESTED ================= */

.suggested-box {
  border-top: 1px solid #eee;
  padding-top: 12px;
  overflow: visible;
  /* 🔥 FIX */
}

.suggested-title {
  font-weight: 600;
  margin-bottom: 8px;
}

.suggested-list {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  overflow-y: visible;
  /* 🔥 FIX */
}

.suggested-item {
  min-width: 120px;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 6px;
  cursor: pointer;
  background: #fff;
  position: relative;
  /* 🔥 BẮT BUỘC */
}

.suggested-item:hover {
  border-color: #ff7a00;
}

.suggested-img {
  width: 100%;
  height: 80px;
  object-fit: contain;
}

.suggested-name {
  font-size: 13px;
  margin-top: 4px;
}

.suggested-price {
  font-size: 13px;
  font-weight: 600;
  color: #e53935;
}

/* ================= SALE + QTY ================= */

.sale-qty-row {
  display: grid;
  grid-template-columns: 1fr 220px;
  gap: 14px;
  margin-top: 16px;
}

/* DISCOUNT */
.discount-box {
  display: grid;
  gap: 8px;
}

.discount-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  border-radius: 10px;
  background: #f7f7f7;
  font-size: 13px;
  border: 1px solid #eee;
}

.discount-row.active {
  background: #fff5f2;
  border-color: #ee4d2d;
  color: #ee4d2d;
  font-weight: 600;
}

.discount-left {
  font-weight: 600;
}

.discount-right {
  color: #666;
  font-size: 12px;
}

/* QUANTITY */
.qty-box {
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 12px;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.qty-label {
  font-size: 13px;
  margin-bottom: 8px;
  color: #555;
  font-weight: 600;
}

.qty-control {
  display: flex;
  border: 1px solid #ddd;
  border-radius: 10px;
  overflow: hidden;
}

.qty-control button {
  width: 38px;
  border: none;
  background: #f0f0f0;
  font-size: 18px;
  cursor: pointer;
}

.qty-control input {
  width: 60px;
  text-align: center;
  border: none;
  outline: none;
}

/* ================= MOBILE ================= */

@media (max-width: 640px) {
  .sale-qty-row {
    grid-template-columns: 1fr;
  }

  .qty-box {
    margin-top: 6px;
  }
}

/* ================= OVERLAY ================= */

.popup-dv-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .55);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(4px);
}

/* ================= POPUP ================= */

.popup-dv {
  width: 95%;
  max-width: 1000px;
  /* height: 90vh; */
  background: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;

  overflow: visible;
  /* 🔥 FIX TOOLTIP */
}

/* HEADER */
.popup-dv-header {
  padding: 14px 18px;
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  border-bottom: 1px solid #eee;
  background: #fafafa;
}

/* TABS */
.tab-bar {
  display: flex;
  border-bottom: 1px solid #eee;
}

.tab {
  flex: 1;
  text-align: center;
  padding: 12px;
  cursor: pointer;
  color: #666;
}

.tab.active {
  color: #ee4d2d;
  border-bottom: 3px solid #ee4d2d;
  font-weight: 600;
}

/* CONTENT */
.tab-content {
  flex: 1;
  overflow-y: auto;
  /* padding: 16px; */
}

/* IMAGE */
.main-img img {
  max-height: 400px;
  border-radius: 12px;
}

.thumb-list {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 12px;
}

.thumb {
  width: 70px;
  height: 70px;
  border-radius: 10px;
  border: 2px solid transparent;
  cursor: pointer;
}

.thumb.active {
  border-color: #ee4d2d;
}

/* PRICE */
.price-summary {
  margin-top: 16px;
  padding: 14px;
  border-radius: 14px;
  border: 1px dashed #ee4d2d;
  background: #fff5f2;
}

.price-row {
  display: flex;
  justify-content: space-between;
}

.old {
  text-decoration: line-through;
  color: #999;
}

.final {
  color: #ee4d2d;
  font-weight: 700;
}

/* FOOTER */
.popup-dv-footer {
  display: flex;
  gap: 12px;
  padding: 10px;
}

.btn {
  flex: 1;
  border-radius: 12px;
  color: #fff;
  border: none;
  padding: 12px;
}

.btn.buy {
  background: linear-gradient(135deg, rgb(7, 149, 217), rgb(0, 120, 190));
}

.btn.rent {
  background: linear-gradient(135deg, #ee4d2d, #d81226);
}

.suggested-item {
  position: relative;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  transition: 0.2s;
}

.suggested-item.active {
  border: 2px solid #ff0904;
  /* background: #f0f7ff; */
  color: #555;
}

.check-icon {
  position: absolute;
  top: 6px;
  right: 8px;
  color: #ff0904;
  font-weight: bold;
}
</style>